import { AppointmentStatus, type Appointment } from "@rmh/defs";
import { DateTime } from "luxon";

export const canCancelAppointment = (appointment: Appointment): boolean => {
  if (!appointment.appointmentDate) {
    return false;
  }

  const isFutureOrToday =
    DateTime.fromISO(appointment.appointmentDate)
      .diff(DateTime.now().startOf("day"))
      .toMillis() >= 0;

  return (
    isFutureOrToday &&
    [
      AppointmentStatus.Scheduled,
      AppointmentStatus.Confirmed,
      AppointmentStatus.Ready,
    ].includes(appointment.appointmentStatus)
  );
};
